import React from 'react';

const ServicesOne = () => {
  return (
    <section className="services-one">
      <div className="services-one__shape-1">
        <img src="assets/images/shapes/services-one-shape-1.png" alt="" />
      </div>
      <div className="container">
        <div className="section-title text-center sec-title-animation animation-style1">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">What We Do</span>
          </div>
          <h2 className="section-title__title title-animation">Programs that restore dignity and opportunity</h2>
        </div>
        <ul className="list-unstyled row">
          <li className="col-xl-3 col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="0">
            <div className="services-one__single">
              <div className="services-one__icon-inner">
                <div className="services-one__icon">
                  <span className="icon-graduation-cap"></span>
                </div>
              </div>
              <h3 className="services-one__title"><a href="donation-details.html">Education Support</a></h3>
              <p className="services-one__text">Scholarships, school meals and supplies so every child can learn and thrive.</p>
              <div className="services-one__read-more">
                <a href="donation-details.html">Read More<span className="icon-right-arrow"></span></a>
              </div>
            </div>
          </li>
          <li className="col-xl-3 col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">
            <div className="services-one__single">
              <div className="services-one__icon-inner">
                <div className="services-one__icon">
                  <span className="icon-helping-hand"></span>
                </div>
              </div>
              <h3 className="services-one__title"><a href="donation-details.html">Community Support</a></h3>
              <p className="services-one__text">Livelihoods and family services that strengthen vulnerable households.</p>
              <div className="services-one__read-more">
                <a href="donation-details.html">Read More<span className="icon-right-arrow"></span></a>
              </div>
            </div>
          </li>
          <li className="col-xl-3 col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
            <div className="services-one__single">
              <div className="services-one__icon-inner">
                <div className="services-one__icon">
                  <span className="icon-healthcare"></span>
                </div>
              </div>
              <h3 className="services-one__title"><a href="donation-details.html">Healthcare Access</a></h3>
              <p className="services-one__text">Mobile clinics, medicines and maternal care for underserved communities.</p>
              <div className="services-one__read-more">
                <a href="donation-details.html">Read More<span className="icon-right-arrow"></span></a>
              </div>
            </div>
          </li>
          <li className="col-xl-3 col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="300">
            <div className="services-one__single">
              <div className="services-one__icon-inner">
                <div className="services-one__icon">
                  <span className="icon-donation"></span>
                </div>
              </div>
              <h3 className="services-one__title"><a href="donation-details.html">Transparent Giving</a></h3>
              <p className="services-one__text">Every donation tracked to programs with clear goals and results.</p>
              <div className="services-one__read-more">
                <a href="donation-details.html">Read More<span className="icon-right-arrow"></span></a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default ServicesOne;
